import { render, staticRenderFns } from "./myArticle.vue?vue&type=template&id=453ea898&scoped=true"
import script from "./myArticle.vue?vue&type=script&lang=js"
export * from "./myArticle.vue?vue&type=script&lang=js"
import style0 from "./myArticle.vue?vue&type=style&index=0&id=453ea898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ea898",
  null
  
)

export default component.exports